import { ReactComponent as TemplateIcon } from "assets/svg/fanCensusFull.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const fanCensusFull: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "Fan Census Full",
  description:
    "Generate a report on the types of music your fans are listening to.",
  templateId: "fanCensusFull",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Fan Census Full",
        },
      },
      numberOfCategories: {
        content: "7",
      },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-copy-of-br-4a1c45"
        : "pp-brand---fa-b6d397",
    fields: [
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
